import React from "react";
import { BespokePrompt } from "@freeplay/shared-code";
import { BespokeProp } from "./BespokeProp";
import { Group } from "./Group";

export type BespokeSelectionContainerProps = {
    testID?: string;
    currentPick?: number;
    oddsType?: string;
    prompt: BespokePrompt;
    disabled?: boolean;
    onSelect: (index: number) => void;
};

export const BespokeSelectionContainer = ({
    prompt,
    currentPick,
    disabled,
    onSelect,
}: BespokeSelectionContainerProps): JSX.Element => {
    const { prompt: promptLabel, options } = prompt;
    return (
        <Group groupTitle={promptLabel}>
            {options.map((option, index) => (
                <BespokeProp
                    key={`bespoke-prop-${option}-${index}`}
                    propString={`${option}`}
                    index={index}
                    isSelected={currentPick === index}
                    onSelect={onSelect}
                    disabled={disabled}
                    isLast={index === options.length - 1}
                />
            ))}
        </Group>
    );
};
